require("core-js/modules/es.array.push.js");
require("core-js/modules/web.dom-exception.stack.js");
require("core-js/modules/esnext.typed-array.to-reversed.js");
require("core-js/modules/esnext.typed-array.to-sorted.js");
require("core-js/modules/esnext.typed-array.with.js");
/* eslint-disable */
let $wxshare = require('./c.wxshare.js');
(function () {
  'use strict';

  let _global;
  let check = {
    /**
     * 判断是否是微信
     */
    isWeiXin() {
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) + '' === 'micromessenger') {
        return true;
      } else {
        return false;
      }
    },
    /**
     * 判断是否是企业微信
     */
    isEnterpriseWeiXin() {
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/wxwork/i) + '' === 'wxwork') {
        return true;
      } else {
        return false;
      }
    },
    /**
     * 判断环境是否是支付宝环境
     */
    isAliClient() {
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/AlipayClient/i) + '' === "alipayclient") {
        return true;
      } else {
        return false;
      }
    },
    /**
     * 判断是否是pc端
     */
    isPcTerminal() {
      const ua = window.navigator.userAgent.toLowerCase();
      if (/phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/ig.test(ua)) {
        return false;
      } else {
        return true;
      }
    },
    /**
     * 判断是否为空
     * @param { any }
     */
    isEmpty(obj) {
      // 字符串检测
      // if( this.isStr(obj) ) {
      //    obj = this.trimSide(obj);
      // }
      if (!obj || obj === 0 && obj === '') {
        return true;
      }
      //检验数组
      if (Array.prototype.isPrototypeOf(obj) && obj.length === 0) {
        return true;
      }
      //检验对象
      if (Object.prototype.isPrototypeOf(obj)) {
        for (var key in obj) {
          return false;
        }
        return true;
      }
      return false;
    },
    // 数组是否存在空值
    // hasEmpty(arr) {
    //   return arr.some((item) => {
    //     return this.isEmpty(item)
    //   })
    // },
    // 判断否有空值
    hasEmpty() {
      let st = false;
      for (let key in arguments) {
        if (this.isEmpty(arguments[key])) {
          st = !st;
          break;
        }
      }
      return st;
    },
    // 数组是否全为空
    everyEmpty(arr) {
      return arr.every(item => {
        return this.isEmpty(item);
      });
    },
    // 字符串不区分大小对比
    isEqualsIgnorecase(str1, str2) {
      if (str1.toUpperCase() === str2.toUpperCase()) {
        return true;
      } else {
        return false;
      }
    },
    /**
     * 判断是否是数字
     * @param {*} value
     */
    isNum(value) {
      var patrn = /^(-)?\d+(\.\d+)?$/;
      if (patrn.exec(value) === null || value === '') {
        return false;
      } else {
        return true;
      }
    },
    /**
     * 判断号码是否为移动号码
     * @param {*} value
     */
    isMobileNumber(value) {
      let patrn = /1(3[4-9]|4[7]|5[012789]|7[28]|8[23478]|9[578])\d{8}/;
      if (patrn.exec(value) === null || value === '') {
        return false;
      } else {
        return true;
      }
    },
    /**
     * 判断号码是否为联通号码
     * @param {*} value
     */
    isUnicomNumber(value) {
      let patrn = /1(3[0-2]|4[56]|5[56]|6[6]|7[0156]|8[56]|9[6])\d{8}/; //验证规则
      if (patrn.exec(value) === null || value === '') {
        return false;
      } else {
        return true;
      }
    },
    /**
     * 判断号码是否为电信号码
     * @param {*} value
     */
    isTelecomNumber(value) {
      var patrn = /1(3[3]|4[19]|5[3]|7[3479]|8[019]|9[0139])\d{8}/;
      if (patrn.exec(value) === null || value === '') {
        return false;
      } else {
        return true;
      }
    },
    /**
     * 判断是否由指定位数数字组成
     * @param {*} str
     * @param {num} len
     */
    numLen(str, len) {
      if (this.isNum(str)) {
        if (str.toString().length == len) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    /**
     * 是否是字符串
     * @param {*} str
     */
    isStr(str) {
      return typeof str == 'string';
    },
    /**
     * 判断由字母数字组成
     * @param {*} str
     */
    inLetterNum(str) {
      var Regx = /^[A-Za-z0-9]*$/;
      if (Regx.test(str)) {
        return true;
      } else {
        return false;
      }
    },
    /**
     * 判断由字母组成
     * @param {*} str
     */
    isLetter(str) {
      var Regx = /^[A-Za-z]*$/;
      if (Regx.test(str)) {
        return true;
      } else {
        return false;
      }
    },
    /**
     * 保留小数点2位
     * @param {*} value 
     */
    returnFloat(value) {
      var value = Math.round(parseFloat(value) * 100) / 100;
      var xsd = value.toString().split(".");
      if (xsd.length == 1) {
        value = value.toString() + ".00";
        return value;
      }
      if (xsd.length > 1) {
        if (xsd[1].length < 2) {
          value = value.toString() + "0";
        }
        return value;
      }
    },
    /**
     * 判断是否是中文
     * @param {*} str
     */
    isChine(str) {
      var reg = /^[\u4E00-\u9FA5]*$/;
      if (reg.test(str)) {
        return true;
      }
      return false;
    },
    /**
     * 判断是否是正确的六位验证码
     * @param {*} str
     */
    isCurrentCheckCode(code) {
      var reg = /^\d{6}$/;
      if (this.isEmpty(code) || !reg.test(code) || !this.isDigital(code)) {
        return false;
      }
      return true;
    },
    isDigital(str) {
      var reg = /^[0-9]*$/;
      if (!reg.test(str)) {
        return false;
      }
      return true;
    },
    /**
     * 判断是否是方法
     * @param {*} str
     */
    isFun(obj) {
      return Object.prototype.toString.call(obj) == '[object Function]';
    },
    /**
     * 判断是否是数组
     * @param {*} str
     */
    isArr(obj) {
      return Array.isArray(obj);
    },
    /**
     * 判断是否是对象
     * @param {*} str
     */
    isObj(obj) {
      console.log(Object.prototype.toString.call(obj));
      return Object.prototype.toString.call(obj) === '[object Object]';
    },
    /**
     * 判断是否是合法身份证
     * @param {*} str
     */
    isCurrentID(str) {
      var reg = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
      return reg.test(str);
    },
    /**
     * 判断是否是正确的手机号
     * @param {*} str
     */
    isCurrentPhone(phone) {
      var reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
      if (this.isEmpty(phone) || !reg.test(phone)) {
        return false;
      }
      return true;
    },
    /**
     * 判断交易密码，必须字母数字组合
     * regNum为数字
     * regChar为字母
     * @param {*} str
     */
    isCurrentPsd(psd) {
      var regNum = /^[0-9]{6,18}$/;
      var regChar = /^[a-zA-Z]{6,18}$/;
      if (this.isEmpty(psd) || regNum.test(psd) || regChar.test(psd)) {
        return false;
      }
      return true;
    },
    /**
     * 判断密码，必须包含两种
     * regNum为数字
     * regChar为字母
     * regMark为符号
     * @param {*} str
     */
    isCurrentPsd3(psd) {
      var regNum = /^[0-9]{6,18}$/;
      var regChar = /^[a-zA-Z]{6,18}$/;
      var regMark = /^[\W]{6,18}$/;
      if (this.isEmpty(psd) || regNum.test(psd) || regChar.test(psd) || regMark.test(psd)) {
        return false;
      }
      return true;
    },
    /**
     * 是否是IOS
     */
    isIos() {
      var u = navigator.userAgent;
      return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    },

    /**
     * 是否是 android
     */
    isAndroid() {
      var u = navigator.userAgent;
      return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    },

    /**
     * 调取app分享
     * @param {标题} title 
     * @param {描述} content 
     * @param {图片链接} imagePath 
     * @param {分享链接} shareUrl 
     */
    shareToWeChat(title, content, imagePath, shareUrl) {
      let parameter = {
        'title': title,
        'content': content,
        'imagePath': imagePath,
        'url': shareUrl
      };
      if (this.isIos()) {
        window.iosDelegate.recommendationShareClicked(JSON.stringify(parameter));
      } else {
        Native.recommendationShareClicked(JSON.stringify(parameter));
      }
    },
    /**
     * 隐藏app分享
     */
    hideShareClick() {
      if (this.isIos()) {
        window.iosDelegate.hiddenNavBarRightButton();
      } else {
        Native.hideShareClick();
      }
    },
    /**
     * 查询cookie中key的值
     * @param {all cookie} strcookie 
     * @param {key} matchcookie 
     */
    getdescookie(strcookie, matchcookie) {
      var getMatchCookie;
      var arrCookie = strcookie.split(/;/g);
      for (var i = 0; i < arrCookie.length; i++) {
        var arr = arrCookie[i].replace(/\s/g, '').split('=');
        if (matchcookie === arr[0]) {
          getMatchCookie = arr[1];
          break;
        }
      }
      return getMatchCookie;
    },
    /**
     * 密码加密
     */
    encryptByDES(message, key) {
      var cryptoJS = require('crypto-js');
      let keyHex = cryptoJS.enc.Utf8.parse(key);
      let encrypted = cryptoJS.DES.encrypt(message, keyHex, {
        mode: cryptoJS.mode.ECB,
        padding: cryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    encryptByAES(message, key) {
      var cryptoJS = require('crypto-js');
      let keyHex = cryptoJS.enc.Utf8.parse(key);
      let encrypted = cryptoJS.AES.encrypt(message, keyHex, {
        mode: cryptoJS.mode.ECB,
        padding: cryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    /**
     * 银行卡号Luhn校验算法
     * luhn校验规则：16位银行卡号（19位通用）:
     * 1.将未带校验位的 15（或18）位卡号从右依次编号 1 到 15（18），位于奇数位号上的数字乘以 2。
     * 2.将奇位乘积的个十位全部相加，再加上所有偶数位上的数字。
     * 3.将加法和加上校验位能被 10 整除。
     * @param {*} bankno
     */
    luhnCheck(bankno) {
      // 取出最后一位（与luhn进行比较）
      var lastNum = bankno.substr(bankno.length - 1, 1);
      // 前15或18位
      var first15Num = bankno.substr(0, bankno.length - 1);
      var newArr = [];
      // 前15或18位倒序存进数组
      for (var i = first15Num.length - 1; i > -1; i--) {
        newArr.push(first15Num.substr(i, 1));
      }
      // 奇数位*2的积 <9
      var arrJiShu = [];
      // 奇数位*2的积 >9
      var arrJiShu2 = [];
      // 偶数位数组
      var arrOuShu = [];
      for (var j = 0; j < newArr.length; j++) {
        if ((j + 1) % 2 === 1) {
          // 奇数位
          if (parseInt(newArr[j]) * 2 < 9) {
            arrJiShu.push(parseInt(newArr[j]) * 2);
          } else {
            arrJiShu2.push(parseInt(newArr[j]) * 2);
          }
        } else {
          // 偶数位
          arrOuShu.push(newArr[j]);
        }
      }
      // 奇数位*2 >9 的分割之后的数组个位数
      var jishuChild1 = [];
      // 奇数位*2 >9 的分割之后的数组十位数
      var jishuChild2 = [];
      for (var h = 0; h < arrJiShu2.length; h++) {
        jishuChild1.push(parseInt(arrJiShu2[h]) % 10);
        jishuChild2.push(parseInt(arrJiShu2[h]) / 10);
      }
      // 奇数位*2 < 9 的数组之和
      var sumJiShu = 0;
      // 偶数位数组之和
      var sumOuShu = 0;
      // 奇数位*2 >9 的分割之后的数组个位数之和
      var sumJiShuChild1 = 0;
      // 奇数位*2 >9 的分割之后的数组十位数之和
      var sumJiShuChild2 = 0;
      var sumTotal = 0;
      for (var m = 0; m < arrJiShu.length; m++) {
        sumJiShu = sumJiShu + parseInt(arrJiShu[m]);
      }
      for (var n = 0; n < arrOuShu.length; n++) {
        sumOuShu = sumOuShu + parseInt(arrOuShu[n]);
      }
      for (var p = 0; p < jishuChild1.length; p++) {
        sumJiShuChild1 = sumJiShuChild1 + parseInt(jishuChild1[p]);
        sumJiShuChild2 = sumJiShuChild2 + parseInt(jishuChild2[p]);
      }
      // 计算总和
      sumTotal = parseInt(sumJiShu) + parseInt(sumOuShu) + parseInt(sumJiShuChild1) + parseInt(sumJiShuChild2);
      // 计算luhn值
      var k = parseInt(sumTotal) % 10 === 0 ? 10 : parseInt(sumTotal) % 10;
      var luhn = 10 - k;
      if (lastNum === luhn + '') {
        return true;
      } else {
        return false;
      }
    },
    /**
     * 验证银行卡号
     * @param {*} bankno
     */
    isBankNo(bankno) {
      bankno = bankno.replace(/\s/g, '');
      if (bankno === '') {
        return false;
      }
      if (bankno.length < 16 || bankno.length > 19) {
        return false;
      }
      // 全数字
      var num = /^\d*$/;
      if (!num.exec(bankno)) {
        return false;
      }
      // 开头6位
      var strBin = '10,18,30,35,37,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,58,60,62,65,68,69,84,87,88,94,95,98,99';
      if (strBin.indexOf(bankno.substring(0, 2)) === -1) {
        return false;
      }
      // Luhn校验
      if (!this.luhnCheck(bankno)) {
        return false;
      }
      return true;
    },
    getCookie(key) {
      var cookie = document.cookie;
      var arr = cookie.split("; ");
      for (var i = 0; i < arr.length; i += 1) {
        var newArr = arr[i].split("=");
        if (key == newArr[0]) {
          return newArr[1];
        }
      }
    },
    setCookie(name, value) {
      var Days = 60; //cookie  天数
      var exp = new Date(); //获得当前时间
      exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000); //换成毫秒
      document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
    }
  };
  let format = {
    /**
     * 数字格式化，三位添加','分割
     * @param { string | number} num
     */
    formatNumber(num) {
      let str = num.toString();
      if (str.indexOf('.') === -1) {
        return (str || 0).replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      }
      let arr = str.split('.');
      return (arr[0] || 0).replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.' + arr[1];
    },
    /**
     * 去掉空字符串
     * @param {*} str
     */
    trimAll(str) {
      return str.replace(/\s+/g, '');
    },
    /**
     * 去掉两边空格
     * @param {*} str
     */
    trimSide(str) {
      return str.replace(/(^\s*)|(\s*$)/g, "");
    },
    /**
     * 数字格式化,指定小数位数
     * @param { string | number} x
     * @param { num } l
     */
    formatMoney(x, l = 2) {
      var ff = parseFloat(x);
      if (isNaN(ff)) {
        return false;
      }
      var f = Math.round(x * Math.pow(10, l)) / Math.pow(10, l);
      var s = f.toString();
      var rs = s.indexOf('.');
      if (rs < 0) {
        rs = s.length;
        s += '.';
      }
      while (s.length <= rs + l) {
        s += '0';
      }
      return s;
    },
    /**
     * 日期处理
     * @param {*} fmt
     * @param {*} date
     */
    dateFtt(fmt, date) {
      var o = {
        "M+": date.getMonth() + 1,
        //月份
        "d+": date.getDate(),
        //日
        "h+": date.getHours(),
        //小时
        "m+": date.getMinutes(),
        //分
        "s+": date.getSeconds(),
        //秒
        "q+": Math.floor((date.getMonth() + 3) / 3),
        //季度
        "S": date.getMilliseconds() //毫秒
      };

      if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o) if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
      return fmt;
    },
    /**
     * 日期格式化
     * @param {*} fmt    yyyy/MM/dd hh:mm:ss
     * @param {*} data  Date()
     */
    formatDate(fmt, data) {
      return this.dateFtt(fmt, data);
    },
    /**
     * 格式化日期
     * @param {*} value
     */
    formatDateTime(value) {
      var date = new Date(value);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? '0' + minute : minute;
      second = second < 10 ? '0' + second : second;
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
    }
  };
  let getParams = {
    /**
     * 获取周岁
     * @param {*} birth
     */
    getAge(birth) {
      try {
        var births = birth.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/);
        var birthday = new Date(births[1], births[3] - 1, births[4]);
        var now = new Date();
        var age = now.getFullYear() - births[1];
        if (now.getMonth() > birthday.getMonth()) {
          return age;
        }
        if (now.getMonth() < birthday.getMonth()) {
          if (age <= 0) {
            return age;
          } else {
            return age - 1;
          }
        }
        if (now.getMonth() == birthday.getMonth()) {
          if (now.getDate() >= birthday.getDate()) {
            return age;
          } else {
            if (age <= 0) {
              return age;
            } else {
              return age - 1;
            }
          }
        }
      } catch (e) {
        return -99;
      }
    },
    /**
     * 获取URL 参数部分
     */
    getUrlParams(url = document.location.toString()) {
      var arrUrl = url.split("?");
      var para = arrUrl[1];
      return para;
    },
    /**
     * 获取域名
     */
    getHostName(full = true) {
      if (full) {
        return window.location.protocol + "//" + window.location.host;
      } else {
        window.location.host;
      }
    }
  };
  let other = {
    /**
     * 动添加载文件
     * @param {*} url
     * @param { css | script } type
     */
    asyncLoadFill(url, type, prototype, callback) {
      let tag = type == 'css' ? 'link' : 'script';
      var s = document.createElement(tag);
      let arrt = type == 'css' ? 'href' : 'src';
      s.className = prototype.class;
      s.id = prototype.id;
      if (!this.isEmpty(prototype.attr)) {
        prototype.attr.map(item => {
          s.setAttribute(item.key, item.value);
        });
      }
      s[arrt] = url;
      var dom = document.getElementsByTagName('head')[0];
      dom.appendChild(s, dom);
      s.onload = function () {
        callback(s);
      };
    },
    toBase64(url) {
      this.getImgToBase64(url, base64 => {
        return base64;
      });
    },
    /**
     * base64转换文件
     * @param {*} base64
     * @param {*} filename
     */
    toFill(base64, filename) {
      //将base64转换为文件
      var arr = base64.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {
        type: mime
      });
    },
    /**
     * 转换base64
     * @param { string } url
     * @param { function } callback
     */
    getImgToBase64(url, callback) {
      //将图片转换为Base64
      var canvas = document.createElement('canvas'),
        ctx = canvas.getContext('2d'),
        img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL('image/png');
        callback(dataURL);
        canvas = null;
      };
    },
    /**
     * 距离现在时间
     * @param {number} year
     * @param {number} month
     * @param {number} day
     */
    dataForNow(year = 0, month = 0, day = 0) {
      // 日期处理函数
      let nowDataArr = this.foramtDate('yyyy-MM-dd', new Date()).split('-');
      nowDataArr[0] = parseInt(nowDataArr[0]) + year;
      nowDataArr[1] = parseInt(nowDataArr[1]) + month <= 9 ? '0' + (parseInt(nowDataArr[1]) + month) : parseInt(nowDataArr[1]) + month;
      nowDataArr[2] = parseInt(nowDataArr[2]) + day <= 9 ? '0' + (parseInt(nowDataArr[2]) + day) : parseInt(nowDataArr[2]) + day;
      return nowDataArr.join('-');
    },
    /**
     * 微信分享
     * @param {*} goods 
     * @param {*} link 
     * @param {*} show 
     */
    wxShare(goods, link, show = true) {
      //检查商品图片是否为绝对路径
      var reg = /(http|https):\/\/([\w.]+\/?)\S*/;
      var regtest = reg.test(goods.goodsImg);
      if (check.isWeiXin()) {
        $wxshare.share({
          link: link,
          // 分享链接注意在绑定公众号绑定好域名，否则分享无效
          title: goods.goodsName,
          // 分享标题
          desc: goods.goodsBrief,
          // 分享描述
          imgUrl: regtest ? goods.goodsImg : process.env.VUE_APP_REQUEST_URL + goods.goodsImg // 分享图
        }, show);
      }
    },
    // 将样式中用到的px单位，直接转换成rem或vw，
    // 以保证页面在各手机屏幕下，整体视觉上的相对一致,避免样式书写时px计算的麻烦
    flexible() {
      const docEl = document.documentElement;
      function setRemUnit() {
        // 完全缩放
        const rem = docEl.clientWidth / 7.5;
        // 限制最大缩放到750px，仅针对转换成rem单位有效
        docEl.style.fontSize = rem + 'px';
      }
      setRemUnit();
      // reset rem unit on page resize
      window.addEventListener('resize', setRemUnit);
      window.addEventListener('pageshow', function (e) {
        if (e.persisted) {
          setRemUnit();
        }
      });
    },
    /**
     * 获取光标位置
     * @param {*元素} el 
     */
    doGetCaretPosition(el) {
      var iCaretPos = 0;
      if (document.selection) {
        el.focus();
        var oSel = document.selection.createRange();
        oSel.moveStart('character', -el.value.length);
        iCaretPos = oSel.text.length;
      } else if (el.selectionStart || el.selectionStart === '0') {
        iCaretPos = el.selectionDirection === 'backward' ? el.selectionStart : el.selectionEnd;
      }
      return iCaretPos;
    },
    /**
     * 数组随机排序（洗牌法）
     * @param {*数组} arr 
     */
    shuffle(arr) {
      var len = arr.length;
      for (var i = 0; i < len - 1; i++) {
        var index = parseInt(Math.random() * (len - i));
        var temp = arr[index];
        arr[index] = arr[len - i - 1];
        arr[len - i - 1] = temp;
      }
      return arr;
    },
    /**
     * 数组去重
     * @param {*} array 
     * @returns 
     */
    uniq(array) {
      var temp = [];
      var index = [];
      var l = array.length;
      for (var i = 0; i < l; i++) {
        for (var j = i + 1; j < l; j++) {
          if (array[i] === array[j]) {
            i++;
            j = i;
          }
        }
        temp.push(array[i]);
        index.push(i);
      }
      return temp;
    }
  };
  let CUtils = {};
  for (let key in check) {
    CUtils[key] = check[key];
  }
  for (let key in format) {
    CUtils[key] = format[key];
  }
  for (let key in getParams) {
    CUtils[key] = getParams[key];
  }
  for (let key in other) {
    CUtils[key] = other[key];
  }
  console.log();
  _global = function () {
    return this || (0, eval)('this');
  }();
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = CUtils;
  } else if (typeof define === 'function' && define.amd) {
    define(function () {
      return CUtils;
    });
  } else {
    !('CUtils' in _global) && (_global.CUtils = CUtils);
  }
})();